module.exports = require("pouchdb-browser");


//////////////////
// WEBPACK FOOTER
// external "pouchdb-browser"
// module id = 21
// module chunks = 0